class BackToTop extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.querySelector('[data-button]');
    this.progress = this.querySelector('[data-progress]');
    this.scrollOffset = window.innerHeight / 2;
    this.progressLength = this.progress?.getTotalLength() || 0;
    this.frame = null;

    if (this.progress) {
      this.progress.style.strokeDasharray = `${this.progressLength} ${this.progressLength}`;
      this.progress.style.strokeDashoffset = this.progressLength;
    }

    this.update();

    this.onButtonClickListener = this.onButtonClick.bind(this);
    this.button.addEventListener('click', this.onButtonClickListener);

    this.onScrollListener = this.requestUpdate.bind(this);
    this.onResizeListener = this.requestUpdate.bind(this);
    window.addEventListener('scroll', this.onScrollListener, { passive: true });
    window.addEventListener('resize', this.onResizeListener, { passive: true });
  }

  disconnectedCallback() {
    this.button.removeEventListener('click', this.onButtonClickListener);
    window.removeEventListener('scroll', this.onScrollListener);
    window.removeEventListener('resize', this.onResizeListener);

    if (this.frame) cancelAnimationFrame(this.frame);
  }

  onButtonClick(e) {
    e.preventDefault();

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }

  requestUpdate() {
    if (this.frame) return;

    this.frame = requestAnimationFrame(() => {
      this.update();
      this.frame = null;
    });
  }

  update() {
    this.scrollOffset = window.innerHeight / 2;
    this.classList.toggle('is-visible', window.scrollY >= this.scrollOffset);

    if (!this.progress || !this.progressLength) return;

    const scrollableHeight = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
    const progress = Math.min(Math.max(window.scrollY / scrollableHeight, 0), 1);
    const offset = this.progressLength * (1 - progress);

    this.progress.style.strokeDashoffset = offset;
  }
}

customElements.define('back-to-top', BackToTop);
